import React, { useState, useRef }  from "react";
import Button from '@mui/material/Button';
import { Card, Empty, Spin } from "antd";
import useTickerStyles from "../../../Components/Snapshot/useTickerStyles";
import PortfolioAllocations from "../../PortfolioAllocations/PortfolioAllocations";
import PortfolioChart  from "../PortfolioChart/PortfolioChart";


const Overview = ({portfolio, portfolioTimeSeries, benchmarkTimeSeries, isDataReady, addTimeseriesSymbols,
                        removeTimeseriesSymbols, extraTimeseries, allTickers}) => {

    const superChartRef = useRef(null);
    const [showAllocations, setShowAllocations] = useState(false);
    const { tickersToStyles, categoryMapping } = useTickerStyles(portfolioTimeSeries, 'tags.style');


    return (
        <Card bordered={false}>
              {isDataReady ? (
                  <>
                      <PortfolioChart
                          portfolioTimeSeries={portfolioTimeSeries}
                          benchmarkTimeSeries={benchmarkTimeSeries}
                          portfolio={portfolio}
                          categoryMapping={categoryMapping}
                          tickerLookup={tickersToStyles}
                          addTimeseriesSymbols={addTimeseriesSymbols}
                            removeTimeseriesSymbols={removeTimeseriesSymbols}
                          extraTimeseries={extraTimeseries}
                          allTickers={allTickers}
                      />
                      {showAllocations ? (
                          <PortfolioAllocations pid={portfolio.id} chartRef={superChartRef} />
                      ) : (
                          <div>
                              <Button onClick={()=>{setShowAllocations(true)}}>SHOW ALLOCATIONS</Button>
                          </div>
                      )}
                  </>
              ) : (
                <Spin><Empty/> </Spin> // Placeholder for loading state or empty data
              )}
        </Card>
    )
}



export default Overview;